import { DocumentColumn } from '@myarvato/shared/models';
import { inject, Injectable } from '@angular/core';
import { DayjsPipe } from '@myarvato/shared/pipelines';
import { TransportDocumentTypePipe } from '../pipes/transport-document-type.pipe';

@Injectable({ providedIn: 'root' })
export class TransportDocumentColumnsProvider {
  private readonly dayjsPipe = inject(DayjsPipe);
  private readonly transportDocumentTypePipe = inject(TransportDocumentTypePipe);

  public getDocumentColumns(): DocumentColumn[] {
    return [
      {
        field: 'creationDate',
        header: 'pages.documents.widget.date',
        transform: (val) => this.dayjsPipe.transform(val, 'L, LT', true),
        cssClass: 'align-middle',
      },
      {
        field: 'documentType',
        header: 'pages.documents.widget.type',
        transform: (val) => this.transportDocumentTypePipe.transform(val),
        cssClass: 'align-middle',
      },
      {
        field: 'fileName',
        header: 'pages.documents.widget.file-name',
        cssClass: 'd-none d-md-table-cell align-middle',
      },
    ];
  }
}
